package uz.ferro.erp.feature.visit.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.user.model.UserDto

@Serializable
data class VisitDto(
    val id: Long?,
    val uuid: String?,
    val user: UserDto?,
    val customer: CustomerDto?,
    val status: VisitStatus?,
    val comment: String?,
    val address: GeoAddressDto?,
    val startTime: String?,
    val endTime: String?,
    val startLocation: TrackLocationDto?,
    val endLocation: TrackLocationDto?
)